// 헤더 우슬롯(#dash-header-slot) 포털 — 검색 input · 주 액션 버튼 자리.
// props: children
import React from 'react';
import SlotPortal from './SlotPortal';

function HeaderRight(props) {
  return <SlotPortal id="dash-header-slot">{props.children}</SlotPortal>;
}

export default HeaderRight;
